import React from 'react';
import { useParams } from 'react-router-dom';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import { FechamentoDeFolhaLista } from 'Component/FechamentoDeFolha';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarFechamentosDeFolhaQuery } from 'View/Service/Default/FechamentosDeFolha';

const FechamentosDeFolha = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const {
    data: { fechamentos_de_folha, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarFechamentosDeFolhaQuery({
    contain: ['VinculosEmpregaticios.Empresas'],
    options: { usuario_id: id },
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/usuarios/editar/${id}/fechamentos-de-folha/adicionar`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={fechamentos_de_folha?.length}
        redirecionar={`/usuarios/editar/${id}/fechamentos-de-folha/adicionar`}
      />
      <div className="bg-white shadow-sm rounded">
        {fechamentos_de_folha?.map((folha) => (
          <FechamentoDeFolhaLista
            key={`${folha.id}-${folha.modificado}`}
            dados={folha}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default FechamentosDeFolha;
